module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/lang.1ea3f255.svg";